
<template>
  <VBadge
    dot
    location="bottom right"
    offset-x="3"
    offset-y="3"
    color="success"
    bordered
  >
    <VAvatar
      class="cursor-pointer mr-3"
    >
      <VImg src="/images/userprofile.png" />
      <VMenu
        activator="parent"
        width="300"
        location="bottom end"
        offset="14px"
      >
        <VList>
          <VListItem>
            <template #prepend>
              <VListItemAction start>
                <VBadge
                  dot
                  location="bottom right"
                  offset-x="3"
                  offset-y="3"
                  color="success"
                >
                  <VAvatar
                    color="primary"
                    variant="tonal"
                  >
                    <VImg  src="/images/userprofile.png" />
                  </VAvatar>
                </VBadge>
              </VListItemAction>
            </template>

            <VListItemTitle v-if="useUserStore().loggedIn" class="font-weight-semibold text-primary">
              {{ useUserStore().user.firstName }}
            </VListItemTitle>
            <VListItemSubtitle >{{ useUserStore().user.username }}</VListItemSubtitle>
          </VListItem>
          <VDivider class="my-2" />

          <VListItem link >
            <template #prepend>
              <VIcon
               color="primary"
                icon="mdi-account-outline"
                size="32"
              />
            </template>

            <VListItemTitle class="text-primary">Profile</VListItemTitle>
          </VListItem>

         
          <VDivider class="my-2" />

          <VListItem  @click="Logout()">
            <template #prepend>
              <VIcon
                color="primary"
                icon="mdi-logout"
                size="32"
              />
            </template>

            <VListItemTitle class="text-primary"> Logout</VListItemTitle>
          </VListItem>
        </VList>
      </VMenu>
    </VAvatar>
  </VBadge>
</template>
<script >
export default{
  methods :{
    Logout() {
      const userStore = useUserStore();
      const delay = 700;
      userStore.$patch({
        snackStatus: "green",
        snackbar: true,
        messageSnack: "Logout Berhasil",
        loggedIn: false,
      });
      setTimeout(() => {
        userStore.$reset();
        navigateTo({ path: "/login" });
      }, delay);
    },
  }
}

</script>